import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable, InjectionToken } from '@angular/core';
import { Page, PageMetadata } from '@tran-monorepo/interfaces';
import { Unit } from '@tran-monorepo/interfaces/applications';
import { Observable } from 'rxjs';

export const UNITS_API_URL = new InjectionToken<string>('UNITS_API_URL');

@Injectable({ providedIn: 'root' })
export class UnitsService {
    private readonly http = inject(HttpClient);
    private readonly apiUrl = inject(UNITS_API_URL);

    public getAll({
        page = 0,
        pageSize = 20
    }: {
        page?: number;
        pageSize?: number;
    }): Observable<Page<Unit, PageMetadata>> {
        const params = new HttpParams({ fromObject: { page, pageSize } });

        return this.http.get<Page<Unit, PageMetadata>>(this.apiUrl, {
            params
        });
    }
}
